import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome';
import ArchivedExpo from './archived-expo';
import './expo-list.css';

/** @class ArchivedExposList
  * A component for rendering a collapsable list of
  * archived expos in a series of virtual expos.
  */
export default class ArchivedExposList extends Component {
  /** @constructor
    * Creates a new instance
    * @prop {Object} an object whose keys are the IDs
    * of the archived expos.
    */
  constructor(props) {
    super(props);
    this.state = {collapsed: true}
    this.toggleCollapse = this.toggleCollapse.bind(this);
  }
  /** @function toggleCollapase
    * A function that toggles the display of the list
    */
  toggleCollapse() {
    this.setState({collapsed: !this.state.collapsed});
  }
  /** @function render
    * Renders the list of archived expos
    */
  render() {
    if(this.state.collapsed) {
      return (
        <p className="archive-toggle" onClick={this.toggleCollapse}>
          Archived Shows
          <FontAwesome name="caret-left"/>
        </p>
      );
    } else {
      var archives = Object.entries(this.props.archived).map((item) => (
        <ArchivedExpo key={item[0]} year={item[0]} expoID={item[1]}/>
      ))
      return (
        <div>
          <p className="archive-toggle" onClick={this.toggleCollapse}>
            Archived Shows
            <FontAwesome name="caret-down"/>
          </p>
          <ul className="archive-list">{archives}</ul>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/series-list/archived-expos-list.js